import { Link, useLocation } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SITE } from "../config";

export const StickyCTA = () => {
  const { pathname } = useLocation();
  if (pathname === "/book-demo") return null;

  return (
    <div
      data-testid="sticky-mobile-cta"
      className="fixed inset-x-0 bottom-0 z-40 border-t border-volt/20 bg-[#070913]/95 px-4 py-3 backdrop-blur-xl lg:hidden"
    >
      <div className="flex items-center justify-between gap-3">
        <div className="leading-tight">
          <p className="font-display text-xl font-extrabold tracking-tight text-volt">
            ${SITE.price}
            <span className="ml-1.5 text-xs font-bold text-white">flat</span>
          </p>
          <p className="font-mono text-[10px] uppercase tracking-[0.14em] text-mist">
            Live in 72 hours
          </p>
        </div>
        <Link
          to="/book-demo"
          data-testid="sticky-cta-button"
          className="btn-primary !px-5 !py-2.5 !text-xs"
        >
          Book Free Demo <ArrowRight size={14} strokeWidth={2.5} />
        </Link>
      </div>
    </div>
  );
};
